import { createApp, type Component } from 'vue'
import './shared/styles/tailwind.css'

type IslandLoader = () => Promise<{ default: Component }>

const ISLANDS: Record<string, IslandLoader> = {
  'mode-dashboard':  () => import('./features/shell/ModeDashboard.vue'),
  'mode-training':   () => import('./features/shell/ModeTrainingShell.vue'),
  'mode-history':    () => import('./features/shell/ModeHistoryShell.vue'),
  scoring:           () => import('./features/scoring/ScoringCalculator.vue'),
  training:          () => import('./features/training/TrainingShell.vue'),
  history:          () => import('./features/history/HistoryIsland.vue'),
  'ai-plan':        () => import('./features/ai-plan/AIPlanIsland.vue'),
  'ufpm-roster':    () => import('./features/ufpm/UFPMRosterShell.vue'),
}

async function mountIslands(): Promise<void> {
  const elements = document.querySelectorAll<HTMLElement>('[data-vue-island]')
  for (const el of elements) {
    const name = el.dataset.vueIsland
    if (!name) continue
    const loader = ISLANDS[name]
    if (!loader) {
      console.warn(`[ptr-vue] Unknown island: ${name}`)
      continue
    }
    try {
      const mod = await loader()
      createApp(mod.default).mount(el)
    } catch (err) {
      console.error(`[ptr-vue] Failed to mount island "${name}":`, err)
      // TEMP DIAGNOSTIC: surface mount/runtime errors visibly so "blank" pages
      // show the actual JS error instead of an empty container.
      // Remove this block once the UFPM blank issue is diagnosed + fixed.
      el.innerHTML = `
        <div style="margin:12px;padding:12px 14px;background:#3a1f1f;color:#fcc;border:1px solid #c33;border-radius:8px;font:12px/1.4 monospace;white-space:pre-wrap;">
          <strong>[Vue island mount failed: ${name}]</strong><br>
          ${String(err instanceof Error ? (err.message || err.stack) : err)}<br>
          <span style="opacity:.7">Check Android Studio Logcat (filter: chromium or WebView) for full stack.</span>
        </div>
      `
    }
  }
}

try {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { void mountIslands() })
  } else {
    void mountIslands()
  }
} catch (err) {
  console.error('[ptr-vue] Bootstrap failed:', err)
}
